export const createTimeoutManager = () => {
    const timeouts: Map<number, ReturnType<typeof setTimeout>> = new Map()
    const remove = (id: number) => {
        const timeout = timeouts.get(id)
        clearTimeout(timeout)
        timeouts.delete(id)
    }

    const add = (id: number, timeout: ReturnType<typeof setTimeout>) => {
        timeouts.set(id, timeout)
    }

    return { timeouts, remove, add }
}
